<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">{{'NO'| translate}}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">{{'YES'| translate}}</button>
</div>